import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMaskModule } from 'ngx-mask';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxCurrencyModule } from 'ngx-currency';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatGridListModule } from '@angular/material/grid-list';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { NgxPrintModule } from 'ngx-print';
import { WebcamModule } from 'ngx-webcam';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatNativeDateModule } from '@angular/material/core';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BarcodeModule } from '@progress/kendo-angular-barcodes';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';

@NgModule({
  imports: [CommonModule, NgxMaskModule.forRoot(), MatMomentDateModule],
  declarations: [],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDividerModule,
    FlexLayoutModule,
    MatIconModule,
    MatProgressSpinnerModule,
    NgxMaskModule,
    MatSnackBarModule,
    MatSelectModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTabsModule,
    MatRadioModule,
    MatChipsModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDatepickerModule,
    NgxCurrencyModule,
    MatDatepickerModule,
    MatIconModule,
    MatGridListModule,
    AngularSignaturePadModule,
    NgxPrintModule,
    WebcamModule,
    MatListModule,
    MatDialogModule,
    MatTooltipModule,
    MatNativeDateModule,
    PDFExportModule,
    UploadsModule,
    DragDropModule,
    MatButtonToggleModule,
    MatSliderModule,
    ScrollingModule,
    MatAutocompleteModule,
    BarcodeModule,
    ExcelExportModule,
  ],
})
export class SharedModule {}
